var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "d-flex flex-column bg-gray-40 rounded py-2 px-3",
      attrs: { "data-qa": "welcome_bonus" },
    },
    [
      _c("div", { staticClass: "d-flex align-center" }, [
        _c("span", {
          staticClass: "ui-icon-gift ui-icon-fz-smaller special--text mr-1",
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "text-subtitle-1 text--text",
            attrs: { "data-qa": "welcome_bonus_welcome_bonus" },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.welcomeBonusAmount.toLocaleString()) +
                " \n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "text-body-1 text--text",
            attrs: { "data-qa": "welcome_bonus_welcome_bonus_text" },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  _setup.t(_setup.welcomeBonusAmountText, _setup.options)
                ) +
                "\n    "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "text-caption text-secondary--text text-pre-line" },
        [
          _vm._v(
            _vm._s(
              _setup.t(
                "При оформлении карты лояльности в клинике.\nПотратить можно сразу.",
                _setup.options
              )
            )
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }